  const elementToMove = document.getElementById('LocalizationForm');
            let targetContainer;

  function moveElement() {
                if (window.innerWidth <= 768) { // Verifica se a largura da janela é menor ou igual a 768px (tablet/mobile)
                    targetContainer = document.querySelector('.mobile-menu');
                    if (elementToMove && targetContainer) {
                        targetContainer.prepend(elementToMove);
                    }
                } else {
                    targetContainer = document.querySelector('.menu__item.menu__item--icons');
                    if (elementToMove && targetContainer) {
                        targetContainer.appendChild(elementToMove);
                    }
                }

                if (!elementToMove || !targetContainer) {
                    //console.error('Elemento ou contêiner de destino não encontrado');
                }
            }







// Função para verificar e mudar o src e srcset da imagem
function alterarImagemSeNecessario() {
    var urlAtual = window.location.href;

    // Verifica se a URL contém "eN"
    if (urlAtual.includes("en")) {

              console.log("site en");


                const a = document.querySelector('.footer__select-popout .select-popout__toggle');


                if (a) {

                    a.childNodes[0].textContent = 'EN';
                }
            } else {
                const a = document.querySelector('.footer__select-popout .select-popout__toggle');


                if (a) {

                    a.childNodes[0].textContent = 'PT';
                }
            }
}


// Chama a função quando a página terminar de carregar
window.onload = function() {
  moveElement();

            // Move o elemento ao redimensionar a janela
            window.addEventListener('resize', moveElement);
    alterarImagemSeNecessario();
  /*const elementToMove = document.getElementById('LocalizationForm');

            // Obter o contêiner de destino
            const targetContainer = document.querySelector('.menu__item.menu__item--icons');


            if (elementToMove && targetContainer) {

                targetContainer.appendChild(elementToMove);
            } else {
                console.error('Elemento  não encontrado');
            }*/


  const linkElement = document.querySelector('a[data-value="pt-PT"]');

            // Verificar se o elemento foi encontrado
            if (linkElement) {
                // Selecionar o <span> dentro do elemento <a>
                const spanElement = linkElement.querySelector('span');

                // Verificar se o <span> foi encontrado
                if (spanElement) {
                    // Alterar o texto do <span>
                    spanElement.textContent = 'PT';
                } else {
                    console.error('Elemento <span> não encontrado dentro do link');
                }
            } else {
                console.error('Elemento <a> com data-value="pt-PT" não encontrado');
            }


  const linkElement1 = document.querySelector('a[data-value="en"]');

            // Verificar se o elemento foi encontrado
            if (linkElement1) {
                // Selecionar o <span> dentro do elemento <a>
                const spanElement1 = linkElement1.querySelector('span');

                // Verificar se o <span> foi encontrado
                if (spanElement1) {
                    // Alterar o texto do <span>
                    spanElement1.textContent = 'en';
                } else {
                    console.error('Elemento <span> não encontrado dentro do link');
                }
            } else {
                console.error('Elemento <a> com data-value="en" não encontrado');
            }


/*FOTER*/

    const rteDiv = document.querySelector('.site-footer .rte');

            // Verifica se a div foi encontrada
            if (rteDiv) {
                console.log("frederico");
                const newContent = document.createElement('div');
                newContent.className = 'footer-block footer-block--text aos-init aos-animate fred';
                newContent.setAttribute('data-aos', 'fade-up');
                newContent.setAttribute('data-aos-anchor', '#SiteFooter');
                newContent.setAttribute('data-aos-delay', '300');

                newContent.innerHTML = `
                    <p class="footer-title h5">Ponto Físico de Venda</p>
                    <div class="rte">
                        <p>Rua do Mestre Guilherme Camarinha, 212</p>
                        <p>4200-537 Paranhos, Porto</p>
                    </div>
                `;

                // Insere o novo conteúdo na div 'rte'
                rteDiv.appendChild(newContent);
            } else {
                console.error('Elemento com a classe "rte" não encontrado');
            }



    const socialSharingWrapper = document.querySelector('.social-sharing-wrapper');

            // Seleciona o elemento de destino
            const footerBlockLogo = document.querySelector('.footer-block.footer-block--logo');

            // Verifica se ambos os elementos foram encontrados
            if (socialSharingWrapper && footerBlockLogo) {
                // Move o elemento social-sharing-wrapper para dentro do footer-block--logo
                footerBlockLogo.prepend(socialSharingWrapper);
            } else {
                if (!socialSharingWrapper) {
                    console.error('Elemento com a classe "social-sharing-wrapper" não encontrado');
                }
                if (!footerBlockLogo) {
                    console.error('Elemento com a classe "footer-block footer-block--logo" não encontrado');
                }
            }



   const paymentIconList = document.querySelector('.payment-icon-list');

            // Seleciona o elemento de destino


            // Verifica se ambos os elementos foram encontrados
            if (paymentIconList && footerBlockLogo) {
                // Move o elemento payment-icon-list para o início do footer-block--logo
                footerBlockLogo.appendChild(paymentIconList);
            } else {
                if (!paymentIconList) {
                    console.error('Elemento com a classe "payment-icon-list" não encontrado');
                }
                if (!footerBlockLogo) {
                    console.error('Elemento com a classe "footer-block footer-block--logo" não encontrado');
                }
            }

};
